"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRAINING_POINT_CLOUD_FRAGMENT = void 0;
var client_1 = require("@apollo/client");
exports.TRAINING_POINT_CLOUD_FRAGMENT = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment TrainingPointCloud on TrainingPointCloud {\n    __typename\n    id\n    labels\n    centroids\n    predicted\n    bucketFileName\n    saved\n    created\n    metadata\n  }\n"], ["\n  fragment TrainingPointCloud on TrainingPointCloud {\n    __typename\n    id\n    labels\n    centroids\n    predicted\n    bucketFileName\n    saved\n    created\n    metadata\n  }\n"])));
var templateObject_1;
